<template>
  <!-- 丢损率统计 -->
  <div class="Box">
    <el-card>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="HUB1" name="first">
        <hubOne ref="hub1" @detailData="getDetailPage" />
      </el-tab-pane>
      <el-tab-pane label="HUB2/3" name="second">
        <hubTwoThree ref="hub2" @detailData="getDetailPage" />
      </el-tab-pane>
    </el-tabs>
    </el-card>
    <!-- 丢损明细 -->
    <el-drawer
      ref="drawer"
      :title="titleName"
      :visible.sync="msgDrawer"
      direction="ltr"
      size="70%"
      @close="cancelForm"
    >
      <div style="margin: 20px">
        <el-form>
          <el-row type="flex" justify="left" style="flex-wrap: wrap">
            <el-col :span="8">
              <el-form-item label="运单号(número de waybill)">
                <el-input
                  v-model="inputValue"
                  placeholder="精确搜索，一行一项，最多支持2000行(A pesquisa exata, uma linha de cada vez, suporta até 2000 linhas)"
                  :rows="1"
                  style="width: 95%"
                  type="textarea"
                  @blur="BlockNewline"
                  @keydown.enter.native="BlockNewline"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="丢损类型(Tipo)">
                <el-select
                  v-model="queryForm.params.responsibilityTypes" placeholder="请选择(Favor selecionar)" style="width: 95%"
                  multiple collapse-tags
                >
                  <el-option label="确认丢失(Perda confirmada)" :value="1" />
                  <el-option label="被抢或被盗(Pacote roubado/furtado)" :value="2" />
                  <el-option label="破损(Pacote avariado)" :value="3" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="责任网点(Ponto responsável)">
                <el-select
                  v-model="queryForm.params.siteIds"
                  placeholder="请选择(Favor selecionar)"
                  clearable filterable multiple
                  collapse-tags
                  style="width: 95%"
                >
                  <el-option
                    v-for="item in siteIdList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="margin-bottom: 20px">
          <el-button
            type="primary" plain size="small"
            @click="searchMsg"
          >查询(Consultar)</el-button>
          <el-button type="primary" size="small" @click="exportMsg">导出(Exportar)</el-button>
        </div>
        <el-table
          :data="tableData"
          border max-height="600" style="width: 100%"
        >
          <el-table-column label="序号(No.)" align="center" width="100">
            <template slot-scope="scope">
              <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="运单号(Número de waybill)" prop="waybillNumber" align="center" />
          <el-table-column label="定责时间(Tempo de Responsabilidade)" prop="responsibilityTime" align="center" />
          <el-table-column label="丢损类型(Tipo)" prop="responsibilityTypeName" align="center" />
          <el-table-column label="责任网点(Ponto responsável)" prop="siteName" align="center" />
        </el-table>
        <div class="right">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page.sync="queryForm.pageNumber"
            :page-sizes="[10, 20, 50, 100, 500, 1000]"
            :page-size.sync="queryForm.pageSize"
            :total="total"
            background
            style="margin: 10px 0"
            @current-change="getDatePage"
            @size-change="searchMsg"
          />
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { siteQueryOwnSite } from '@/api/lanshou';
import { detailPage, detailExport } from '@/api/orderApi';
import { goRWExportList } from '@/utils/goExportList';
export default {
  components: {
    hubOne: () => import('./component/hubOne.vue'),
    hubTwoThree: () => import('./component/hubTwoThree.vue')
  },
  data() {
    return {
      activeName: 'first',
      titleName: '',
      msgDrawer: false,
      inputValue: '',
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          // startDate: '', //有汇总行点进详情
          // endDate: '',
          // hubType: null, // HUB类型: 1 HUB1,   2 HUB2
          // responsibilityTypes: null, // 丢损类型: 1 确认丢失, 2 被偷或被抢, 3 破损
          // waybillNumbers: [],
          // siteIds: [], // 责任网点ID列表
          // state: '', // 州 (HUB2专用)
          // regionId: '' // 大区ID (HUB2专用)
        }
      },
      siteIdList: [],
      total: 0,
      tableData: []
    };
  },
  created() {
    this.activeName = 'first';
    this.queryForm.params.hubType = 1;
  },
  methods: {
    BlockNewline() {
      if (!this.inputValue) {
        this.queryForm.params.waybillNumbers = [];
        return;
      }
      let lines = this.inputValue
        .split('\n')
        .filter(line => line.trim() !== '')
        .map(line => line.replace(/\s+/g, ''));
      if (lines.length > 2000) {
        lines = lines.slice(0, 2000);
        this.$message.warning(this.$t('collectionCenter.intercep2'));
      }
      this.inputValue = lines.join('\n');
      this.queryForm.params.waybillNumbers = lines;
    },
    // 查询所有网点
    getBranchList() {
      siteQueryOwnSite().then((res) => {
        if (res.code === 200) {
          this.siteIdList = res.data;
        }
      });
    },
    handleClick() {
      if (this.activeName === 'first') {
        this.queryForm.params.hubType = 1;
        this.$refs.hub1.search();
      }
      if (this.activeName === 'second') {
        this.queryForm.params.hubType = 2;
        this.$refs.hub2.toHub2();
      }
    },
    cancelForm() {
      this.msgDrawer = false;
    },

    // 点击进入详情
    getDetailPage(startDate, endDate, hubType, responsibilityTypes, state, regionId) {
      this.inputValue = '';
      const params = {
        startDate,
        endDate,
        hubType,
        responsibilityTypes,
        siteIds: [],
        waybillNumbers: []
      };
      if (state) params.state = state;
      if (regionId) params.regionId = regionId;
      this.queryForm.params = params;

      this.msgDrawer = true;
      if (!this.siteIdList || this.siteIdList.length <= 0) {
        this.getBranchList();
      }
      this.searchMsg();
    },
    searchMsg() {
      this.queryForm.pageNumber = 1;
      this.getDatePage();
    },
    getDatePage() {
      detailPage(this.queryForm).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    exportMsg() {
      detailExport(this.queryForm.params).then(res => {
        if (res.code === 200) {
          goRWExportList(this).then(() => {
            this.cancelForm();
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.Box{
  box-sizing: border-box;
}
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
